// src/services/CountryService.js
import api from "./api";

export function getAccommodationTypes() {
    return api.get(`/accommodationtype/byuser`);
}